var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-block btn-default pull-right",attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('i',{staticClass:"icon-solicitacao_nova_solicitacao"}),_vm._v(" "),_c('br'),_vm._v("\n\t\t"+_vm._s(_vm.capitalizaNome(_vm._traducao('global', 'novo')))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }